import React, { useState } from 'react';
import { Button } from '../common/Button';
import { Timer } from '../common/Timer';

interface SessionHeaderProps {
  sessionId: string;
  elapsed: string;
  onCopyLink: () => void;
  onLeaveSession: () => void;
  // Voting actions (available to all participants)
  state?: 'collecting' | 'revealed';
  hasAnyVotes?: boolean;
  allVotesIn?: boolean;
  onShowVotes?: () => void;
  onReopenVoting?: () => void;
  onResetVotes?: () => void;
}

export function SessionHeader({ 
  sessionId, 
  elapsed, 
  onCopyLink, 
  onLeaveSession,
  state,
  hasAnyVotes = false,
  allVotesIn = false,
  onShowVotes,
  onReopenVoting,
  onResetVotes,
}: SessionHeaderProps) {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    onCopyLink();
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 mb-4">
      <div className="flex flex-col lg:flex-row lg:items-center gap-4">
        <div className="flex items-center gap-6 flex-wrap">
          <div>
            <label className="text-xs text-gray-500 uppercase tracking-wide block mb-1">
              Session ID
            </label>
            <code className="text-lg font-mono font-semibold text-gray-800 bg-gray-100 px-3 py-1 rounded" aria-label={`Session ID: ${sessionId}`}>
              {sessionId}
            </code>
          </div>
          <div>
            <label className="text-xs text-gray-500 uppercase tracking-wide block mb-1">
              Elapsed Time
            </label>
            <Timer elapsed={elapsed} aria-label={`Elapsed time: ${elapsed}`} />
          </div>
        </div>
        {state && (
          <div className="flex flex-wrap gap-2 lg:flex-1 lg:justify-center">
            <Button
              variant="primary"
              size="sm"
              onClick={onShowVotes}
              disabled={state === 'revealed'}
            >
              Show Votes
            </Button>
            <Button
              variant="secondary"
              size="sm"
              onClick={onReopenVoting}
              disabled={state === 'collecting' || !allVotesIn}
            >
              Reopen Voting
            </Button>
            <Button
              variant="secondary"
              size="sm"
              onClick={onResetVotes}
              disabled={!hasAnyVotes}
            >
              Reset Votes
            </Button>
          </div>
        )}
        <div className="flex flex-wrap gap-2 lg:ml-auto">
          <Button
            variant="secondary"
            size="sm"
            onClick={handleCopy}
          >
            {copied ? '✓ Copied!' : 'Copy Link'}
          </Button>
          <Button
            variant="secondary"
            size="sm"
            onClick={onLeaveSession}
          >
            Leave
          </Button>
        </div>
      </div>
    </div>
  );
}

